import React from 'react';
import './Banner.css';

import { Heading, Button } from '../../components'; // Importing reusable Heading and Button components



const Banner = () => {
  return (
    <section className="banner">
      <div className="content">

        {/* Heading component with dynamic props */}
        <Heading title={'Transforming Ideas into Intelligent Solutions'} subTitle={'Join Us'} linear sideHeading />

        <Button link={'Request-Estimate'} title={'Get Your Estimate'} />

      </div>
    </section>
  );
};

export default Banner;